/**
 * Shared expense total math: discount applies to the pre-CC subtotal, then CC is added.
 * Lists/payroll/vehicle rollups only read the stored `amount`, so this formula must be
 * used at save time (dialogs) and when populating from invoice extraction.
 */
/** Dollar amount of the discount, capped at the subtotal. */
export const discountDollars = (subtotal, discountType, discountValue) => {
    if (!discountType || discountValue == null || Number.isNaN(discountValue) || discountValue <= 0) {
        return 0;
    }
    const safeSubtotal = Math.max(0, subtotal);
    if (discountType === 'percent') {
        const pct = Math.min(100, discountValue);
        return Math.min(safeSubtotal, (safeSubtotal * pct) / 100);
    }
    return Math.min(safeSubtotal, discountValue);
};
/**
 * Canonical stored expense amount:
 * `subtotal - discount$ + creditCardCharge`
 */
export const computeExpenseAmount = ({ subtotal, discountType = null, discountValue = null, creditCardCharge = null, }) => {
    const safeSubtotal = Math.max(0, subtotal || 0);
    const discount = discountDollars(safeSubtotal, discountType, discountValue);
    const cc = creditCardCharge != null && !Number.isNaN(creditCardCharge) && creditCardCharge > 0
        ? creditCardCharge
        : 0;
    return Math.max(0, safeSubtotal - discount + cc);
};
/** Normalize raw discount fields from Firestore / form input. */
export const normalizeDiscountType = (value) => {
    if (value === 'percent' || value === 'amount')
        return value;
    return null;
};
export const normalizeDiscountValue = (value, discountType) => {
    if (typeof value !== 'number' || Number.isNaN(value) || value <= 0)
        return null;
    if (!discountType)
        return null;
    if (discountType === 'percent')
        return Math.min(100, value);
    return value;
};
